define([
    'mixins/models/projectbased',
    'moment-wrapper'
], (Model, moment) => Model.extend({

    defaults () {
        return {
            id: null,
            start_date: moment().formatDateApi(),
            end_date: moment().add('months', 1).
                add('days', -1).
                formatDateApi(),
            payer_id: null,
            fee: 0,
            budget: 0,
            cpm_planned: 0,
            cpc_planned: 0,
            cpa_planned: 0,
            clicks_planned: 0,
            impressions_planned: 0,
            conversions_planned: 0,
            additional_service_id: null
        };
    }

}));
